module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-modal",
    class: {
      'is-alert': _vm.alert,
      'is-prompt': _vm.prompt,
      'is-img': _vm.img
    }
  }, [_c('transition', {
    attrs: {
      "name": "zoom-in"
    }
  }, [(_vm.dataShow) ? _c('div', [_c('div', {
    staticClass: "mask"
  }), _c('div', {
    staticClass: "vbl-modal-content-wrap",
    class: {
      'vertical-center': _vm.verticalCenter
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.onClickModal($event)
      }
    }
  }, [(_vm.img) ? _c('vbl-icon', {
    staticClass: "vbl-modal-close",
    attrs: {
      "type": "ion-ios-close-empty",
      "size": "30"
    },
    on: {
      "click": _vm.onCancel
    }
  }) : _vm._e(), _c('div', {
    staticClass: "vbl-modal-content animation-content",
    style: ({
      'width': _vm.contentWidth
    })
  }, [(!_vm.hideHeader) ? _c('div', {
    staticClass: "vbl-modal-header"
  }, [_c('vbl-icon', {
    staticClass: "vbl-modal-close",
    attrs: {
      "type": "ion-ios-close-empty",
      "size": "30"
    },
    on: {
      "click": _vm.onCancel
    }
  }), _c('div', {
    staticClass: "vbl-modal-title"
  }, [_vm._v(_vm._s(_vm.title))])], 1) : _vm._e(), _c('div', {
    staticClass: "vbl-modal-body"
  }, [(_vm.content) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : (_vm.src) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.src
    }
  })]) : _vm._t("default")], 2), (!_vm.hideFooter) ? _c('div', {
    staticClass: "vbl-modal-footer"
  }, [_c('vbl-button', {
    on: {
      "click": _vm.onOk
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.okText) + "\n                        ")]), (!_vm.hideCancel) ? _c('vbl-button', {
    attrs: {
      "theme": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.onCancel('button')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.cancelText) + "\n                        ")]) : _vm._e()], 1) : _vm._e()])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6420e70a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblModal/src/vblModal.vue
// module id = 272
// module chunks = 0